import React, { useContext, useEffect, useState } from 'react';
import '../assets/css/cookie.css';
import MultiLingualContent, { getText } from '../config/multilingualContent';
import { LanguageContext } from '../config/multilingualContext';

const STORAGE_KEY = 'cookie_consent';

const CookieConsent = ({ position = 'left' }) => {
  const { language } = useContext(LanguageContext);
  const [visible, setVisible] = useState(false);
  const [accepted, setAccepted] = useState(null);

  useEffect(() => {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (!stored) setVisible(true);
      else setAccepted(stored);
    } catch (e) {
      // ignore
      setVisible(true);
    }
  }, []);

  const save = (value) => {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      // ignore write errors
    }
    setAccepted(value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className={`cookie-consent cookie-consent--${position}`} role="dialog" aria-live="polite">
      <div className="cookie-consent__inner">
        <div className="cookie-consent__text">
          <strong>{getText('cookieTitle', language) || 'We use cookies'}</strong>
          <div className="cookie-consent__desc">
            {getText('cookieDesc', language) || (
              <>
                <span>To improve your experience and analyze usage.</span>
              </>
            )}
          </div>
        </div>
        <div className="cookie-consent__actions">
          <button className="btn btn--ghost" onClick={() => save('declined')}>{getText('decline', language) || 'Decline'}</button>
          <button className="btn btn--primary" onClick={() => save('accepted')}>{getText('accept', language) || 'Accept'}</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
